// Hierarchical equipment taxonomy for EquipmentHub India
// 15 major groups, 130+ subcategories.

export const TAXONOMY = [
  {
    id: "cranes",
    name: "Cranes",
    tagline: "Mobile, tower, crawler & rough-terrain cranes",
    image: "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?w=1200&q=80",
    subcategories: [
      { id: "mobile-crane", name: "Mobile Crane" },
      { id: "all-terrain-crane", name: "All Terrain Crane" },
      { id: "rough-terrain-crane", name: "Rough Terrain Crane" },
      { id: "crawler-crane", name: "Crawler Crane" },
      { id: "tower-crane", name: "Tower Crane" },
      { id: "truck-mounted-crane", name: "Truck Mounted Crane" },
      { id: "tyre-mounted-mobile-crane-100t", name: "Tyre Mounted Mobile Crane 100T" },
      { id: "tyre-mounted-mobile-crane-150t", name: "Tyre Mounted Mobile Crane 150T" },
      { id: "tyre-mounted-mobile-crane-250t", name: "Tyre Mounted Mobile Crane 250T" },
      { id: "tyre-mounted-mobile-crane-300t", name: "Tyre Mounted Mobile Crane 300T" },
      { id: "tyre-mounted-mobile-crane-350t", name: "Tyre Mounted Mobile Crane 350T" },
      { id: "tyre-mounted-mobile-crane-500t", name: "Tyre Mounted Mobile Crane 500T" },
    ],
  },
  {
    id: "earthmoving",
    name: "Earthmoving Equipment",
    tagline: "Excavators, loaders, dozers, dumpers & compaction",
    image: "https://images.unsplash.com/photo-1603814929877-d5d927322656?w=1200&q=80",
    subcategories: [
      { id: "excavator", name: "Excavator" },
      { id: "mini-excavator", name: "Mini Excavator" },
      { id: "wheeled-excavator", name: "Wheeled Excavator" },
      { id: "long-reach-excavator", name: "Long Reach Excavator" },
      { id: "amphibious-excavator", name: "Amphibious Excavator" },
      { id: "wheel-loader", name: "Wheel Loader" },
      { id: "compact-loader", name: "Compact Loader" },
      { id: "crawler-loader", name: "Crawler Loader" },
      { id: "bulldozer", name: "Bulldozer / Crawler Dozer" },
      { id: "motor-grader", name: "Motor Grader" },
      { id: "backhoe-loader", name: "Backhoe Loader" },
      { id: "skid-steer-loader", name: "Skid Steer Loader" },
      { id: "articulated-dump-truck", name: "Articulated Dump Truck" },
      { id: "rigid-dump-truck", name: "Rigid Dump Truck" },
      { id: "motor-scraper", name: "Motor Scraper" },
      { id: "soil-compactor", name: "Soil Compactor" },
      { id: "vibratory-roller", name: "Vibratory Roller" },
      { id: "pneumatic-tyred-roller", name: "Pneumatic Tyred Roller" },
      { id: "tandem-roller", name: "Tandem Roller" },
      { id: "rock-breaker", name: "Rock Breaker" },
      { id: "trencher", name: "Trencher" },
    ],
  },
  {
    id: "material-handling",
    name: "Material Handling Equipment",
    tagline: "Tower cranes, forklifts, hoists & jib cranes",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&q=80",
    subcategories: [
      { id: "boom-lift", name: "Boom Lift" },
      { id: "scissor-lift", name: "Scissor Lift" },
      { id: "telehandler", name: "Telehandler" },
      { id: "man-lift", name: "Man Lift" },
      { id: "forklift", name: "Forklift" },
      { id: "tower-crane", name: "Tower Crane" },
      { id: "builder-hoist", name: "Builder Hoist" },
      { id: "material-hoist", name: "Material Hoist" },
      { id: "rack-pinion-hoist", name: "Rack & Pinion Hoist" },
      { id: "winches", name: "Winches" },
      { id: "container-handler", name: "Container Handler" },
      { id: "conveyor-system", name: "Conveyor System" },
      { id: "pallet-truck", name: "Pallet Truck" },
      { id: "material-handling", name: "Other Material Handling" },
    ],
  },
  {
    id: "piling-foundation",
    name: "Piling & Foundation Equipment",
    tagline: "Rigs, drivers, cutters & diaphragm walls",
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=1200&q=80",
    subcategories: [
      { id: "piling-rig", name: "Piling Rig" },
      { id: "hydraulic-drilling-rig", name: "Hydraulic Drilling Rig" },
      { id: "anchor-rig", name: "Anchor Rig" },
      { id: "vibro-hammer", name: "Vibro Hammer" },
      { id: "pile-driver", name: "Pile Driver" },
      { id: "sheet-pile-driver", name: "Sheet Pile Driver" },
      { id: "trench-cutter", name: "Trench Cutter" },
      { id: "diaphragm-wall-grab", name: "Diaphragm Wall Grab" },
      { id: "desander", name: "Desander" },
      { id: "pile-breaker", name: "Pile Breaker" },
    ],
  },
  {
    id: "concreting",
    name: "Concreting Equipment",
    tagline: "Batching plants, pumps, mixers & booms",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&q=80",
    subcategories: [
      { id: "batching-plant", name: "Batching Plant" },
      { id: "concrete-pump", name: "Concrete Pump" },
      { id: "transit-mixer", name: "Transit Mixer" },
      { id: "concrete-placing-boom", name: "Concrete Placing Boom" },
      { id: "shotcrete-machine", name: "Shotcrete Machine" },
      { id: "grouting-plant", name: "Grouting Plant" },
      { id: "concrete-mixer", name: "Concrete Mixer" },
      { id: "concrete-recycler", name: "Concrete Recycler" },
      { id: "concrete-distributor", name: "Concrete Distributor" },
      { id: "concrete-boom-pump", name: "Concrete Boom Pump" },
      { id: "slipform-paver", name: "Slipform Paver" },
      { id: "self-loading-mixer", name: "Self-Loading Mixer" },
      { id: "self-loading-transit-mixer-2cum", name: "Self Loading Transit Mixer 2 CUM" },
      { id: "self-loading-transit-mixer-4cum", name: "Self Loading Transit Mixer 4 CUM" },
      { id: "self-loading-transit-mixer-4-3cum", name: "Self Loading Transit Mixer 4.3 CUM" },
      { id: "reversible-drum-mixer", name: "Reversible Drum Mixer" },
    ],
  },
  {
    id: "road-construction",
    name: "Road Construction Equipment",
    tagline: "Asphalt plants, pavers, milling & sprayers",
    image: "https://images.unsplash.com/photo-1553048686-e3d0396506b9?w=1200&q=80",
    subcategories: [
      { id: "asphalt-plant", name: "Asphalt Plant" },
      { id: "wmm-plant", name: "WMM Plant" },
      { id: "soil-stabilizer", name: "Soil Stabilizer" },
      { id: "asphalt-paver", name: "Asphalt Paver" },
      { id: "concrete-paver", name: "Concrete Paver" },
      { id: "cold-milling-machine", name: "Cold Milling Machine" },
      { id: "bitumen-sprayer", name: "Bitumen Sprayer" },
      { id: "asphalt-feeder", name: "Asphalt Feeder" },
      { id: "kerb-casting-machine", name: "Kerb Casting Machine" },
    ],
  },
  {
    id: "crushing-screening",
    name: "Crushing & Screening Equipment",
    tagline: "Jaw, cone, VSI, mobile crushers & screens",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80",
    subcategories: [
      { id: "jaw-crusher", name: "Jaw Crusher" },
      { id: "cone-crusher", name: "Cone Crusher" },
      { id: "impact-crusher", name: "Impact Crusher" },
      { id: "mobile-crusher", name: "Mobile Crusher" },
      { id: "vsi-crusher", name: "VSI Crusher" },
      { id: "vibrating-screen", name: "Vibrating Screen" },
      { id: "vibrating-feeder", name: "Vibrating Feeder" },
      { id: "sand-washing-plant", name: "Sand Washing Plant" },
      { id: "air-classifier", name: "Air Classifier" },
    ],
  },
  {
    id: "utility-power",
    name: "Utility & Power Equipment",
    tagline: "DG sets, lighting towers, pumps & compressors",
    image: "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=1200&q=80",
    subcategories: [
      { id: "generator", name: "DG Set / Generator" },
      { id: "lighting-tower", name: "Lighting Tower" },
      { id: "compressor", name: "Air Compressor" },
      { id: "screw-compressor", name: "Screw Compressor" },
      { id: "water-pump", name: "Water Pump" },
      { id: "dewatering-system", name: "Dewatering System" },
      { id: "boiler", name: "Boiler" },
      { id: "chilling-plant", name: "Chilling Plant" },
      { id: "cooling-tower", name: "Cooling Tower" },
      { id: "air-handling-unit", name: "Air Handling Unit (AHU)" },
      { id: "vrv-vrf-system", name: "VRV / VRF System" },
      { id: "ice-plant", name: "Ice Plant" },
      { id: "hvac-chiller", name: "HVAC Chiller" },
    ],
  },
  {
    id: "transmission-line",
    name: "Transmission Line Equipment",
    tagline: "Pullers, tensioners & compressors",
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1200&q=80",
    subcategories: [
      { id: "puller", name: "Puller" },
      { id: "tensioner", name: "Tensioner" },
      { id: "puller-cum-tensioner", name: "Puller Cum Tensioner" },
      { id: "transmission-winch", name: "Transmission Winch" },
      { id: "hydraulic-compressor", name: "Hydraulic Compressor" },
    ],
  },
  {
    id: "railway",
    name: "Railway Equipment",
    tagline: "RRVs, tampers, welders & tower wagons",
    image: "https://images.pexels.com/photos/93398/pexels-photo-93398.jpeg?auto=compress&cs=tinysrgb&w=1200",
    subcategories: [
      { id: "rrv", name: "RRV" },
      { id: "rail-threader", name: "Rail Threader" },
      { id: "sleeper-laying-equipment", name: "Sleeper Laying Equipment" },
      { id: "tamper", name: "Tamper" },
      { id: "ballast-regulator", name: "Ballast Regulator" },
      { id: "flash-butt-welder", name: "Flash Butt Welder" },
      { id: "railway-utility-vehicle", name: "Railway Utility Vehicle" },
      { id: "tower-wagon", name: "Tower Wagon" },
    ],
  },
  {
    id: "survey",
    name: "Survey Equipment",
    tagline: "Total stations & DGPS",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1200&q=80",
    subcategories: [
      { id: "total-station", name: "Total Station" },
      { id: "dgps", name: "DGPS" },
    ],
  },
  {
    id: "tunneling",
    name: "Tunneling Equipment",
    tagline: "TBM, road headers, drill jumbos & miners",
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1200&q=80",
    subcategories: [
      { id: "tbm", name: "TBM" },
      { id: "road-header", name: "Road Header" },
      { id: "drill-jumbo", name: "Drill Jumbo" },
      { id: "rock-bolting-machine", name: "Rock Bolting Machine" },
      { id: "surface-miner", name: "Surface Miner" },
      { id: "drill-wagon", name: "Drill Wagon" },
    ],
  },
  {
    id: "transportation",
    name: "Transportation Equipment",
    tagline: "Trailers, tankers, dumpers & tippers",
    image: "https://images.pexels.com/photos/93398/pexels-photo-93398.jpeg?auto=compress&cs=tinysrgb&w=1200",
    subcategories: [
      { id: "low-bed-trailer", name: "Low Bed Trailer" },
      { id: "hydraulic-trailer", name: "Hydraulic Trailer" },
      { id: "water-tanker", name: "Water Tanker" },
      { id: "fuel-bowser", name: "Fuel Bowser" },
      { id: "dumper", name: "Dumper" },
      { id: "tipper", name: "Tipper" },
      { id: "truck-mounted-crane", name: "Truck Mounted Crane" },
      { id: "tractor-trailer", name: "Tractor Trailer" },
      { id: "trailer", name: "Trailer (General)" },
    ],
  },
  {
    id: "marine",
    name: "Marine Equipment",
    tagline: "Crane barges, jack-up & transport barges",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80",
    subcategories: [
      { id: "crane-barge", name: "Crane Barge" },
      { id: "jack-up-barge", name: "Jack Up Barge" },
      { id: "transport-barge", name: "Transport Barge" },
      { id: "split-barge", name: "Split Barge" },
      { id: "tug-boat", name: "Tug Boat" },
      { id: "dredger", name: "Dredger" },
    ],
  },
  {
    id: "mining",
    name: "Mining Equipment",
    tagline: "Draglines, rope shovels, blast-hole drills & haul trucks",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=1200&q=80",
    subcategories: [
      { id: "dragline", name: "Dragline" },
      { id: "rope-shovel", name: "Rope Shovel / Electric Shovel" },
      { id: "hydraulic-shovel", name: "Hydraulic Mining Shovel" },
      { id: "blast-hole-drill", name: "Blast Hole Drill" },
      { id: "wagon-drill", name: "Wagon Drill" },
      { id: "haul-truck", name: "Haul Truck / Off-Highway Dumper" },
      { id: "wheel-dozer", name: "Wheel Dozer" },
      { id: "coal-hauler", name: "Coal Hauler" },
      { id: "underground-loader", name: "Underground Loader (LHD)" },
      { id: "continuous-miner", name: "Continuous Miner" },
      { id: "long-wall-mining", name: "Long Wall Mining System" },
    ],
  },
  {
    id: "demolition",
    name: "Demolition Equipment",
    tagline: "Breakers, shears, crushers & demolition robots",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1200&q=80",
    subcategories: [
      { id: "hydraulic-breaker", name: "Hydraulic Breaker" },
      { id: "demolition-shear", name: "Demolition Shear" },
      { id: "concrete-pulverizer", name: "Concrete Pulverizer" },
      { id: "crusher-attachment", name: "Crusher Attachment" },
      { id: "demolition-robot", name: "Demolition Robot" },
      { id: "wire-saw", name: "Wire Saw" },
      { id: "wall-saw", name: "Wall Saw" },
      { id: "core-drill", name: "Core Drill" },
      { id: "high-reach-demolition-boom", name: "High Reach Demolition Boom" },
    ],
  },
  {
    id: "solar-renewable",
    name: "Solar & Renewable Equipment",
    tagline: "Solar pile drivers, tracker installers & wind erection",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&q=80",
    subcategories: [
      { id: "solar-pile-driver", name: "Solar Pile Driver" },
      { id: "solar-tracker-installer", name: "Solar Tracker Installer" },
      { id: "solar-panel-cleaner", name: "Solar Panel Cleaner (Robot)" },
      { id: "wind-turbine-erection-crane", name: "Wind Turbine Erection Crane" },
      { id: "wind-blade-transporter", name: "Wind Blade Transporter" },
      { id: "battery-storage-system", name: "Battery Storage System (BESS)" },
      { id: "solar-inverter", name: "Solar Inverter" },
    ],
  },
  {
    id: "attachments",
    name: "Attachments & Accessories",
    tagline: "Buckets, breakers, quick couplers, augers & grapples",
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=1200&q=80",
    subcategories: [
      { id: "gp-bucket", name: "General Purpose Bucket" },
      { id: "rock-bucket", name: "Rock Bucket" },
      { id: "clamshell-bucket", name: "Clamshell Bucket" },
      { id: "breaker-attachment", name: "Breaker Attachment" },
      { id: "quick-coupler", name: "Quick Coupler" },
      { id: "auger-attachment", name: "Auger Attachment" },
      { id: "ripper-attachment", name: "Ripper Attachment" },
      { id: "grapple", name: "Grapple" },
      { id: "thumb-attachment", name: "Thumb Attachment" },
      { id: "crusher-bucket", name: "Crusher Bucket" },
      { id: "compactor-plate", name: "Compactor Plate" },
      { id: "magnet-attachment", name: "Magnet Attachment" },
      { id: "tilt-rotator", name: "Tilt Rotator" },
    ],
  },
  {
    id: "cleaning-maintenance",
    name: "Cleaning & Maintenance Equipment",
    tagline: "Sweepers, scrubbers, jetters & vacuum trucks",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80",
    subcategories: [
      { id: "road-sweeper", name: "Road Sweeper" },
      { id: "industrial-scrubber", name: "Industrial Scrubber" },
      { id: "high-pressure-washer", name: "High Pressure Washer / Jetter" },
      { id: "vacuum-truck", name: "Vacuum Truck / Suction Machine" },
      { id: "sewer-jetting-machine", name: "Sewer Jetting Machine" },
      { id: "septic-tank-cleaner", name: "Septic Tank Cleaner" },
      { id: "drain-cleaning-machine", name: "Drain Cleaning Machine" },
      { id: "façade-cleaning-cradle", name: "Facade Cleaning Cradle" },
    ],
  },
  {
    id: "safety-fire",
    name: "Safety & Fire Equipment",
    tagline: "Fire tenders, gas detectors, safety nets & harnesses",
    image: "https://images.unsplash.com/photo-1587574293340-e0011c4e8ecf?w=1200&q=80",
    subcategories: [
      { id: "fire-tender", name: "Fire Tender" },
      { id: "foam-pump", name: "Foam Pump" },
      { id: "gas-detector", name: "Gas Detector" },
      { id: "safety-net-system", name: "Safety Net System" },
      { id: "fall-arrest-system", name: "Fall Arrest System" },
      { id: "sprinkler-system", name: "Sprinkler System" },
      { id: "fire-extinguisher-refill", name: "Fire Extinguisher Refill" },
      { id: "smoke-detector-system", name: "Smoke Detector System" },
    ],
  },
];

// Flat category list (id → name) for search/select components
export const ALL_SUBCATEGORIES = TAXONOMY.flatMap((g) =>
  g.subcategories.map((s) => ({ ...s, group_id: g.id, group_name: g.name }))
);

// Lookup: subcategory id → parent group id
export const CATEGORY_TO_GROUP = ALL_SUBCATEGORIES.reduce((acc, s) => {
  acc[s.id] = s.group_id;
  return acc;
}, {});

// Group lookup by id
export const GROUP_BY_ID = TAXONOMY.reduce((acc, g) => {
  acc[g.id] = g;
  return acc;
}, {});
